import React from 'react'
import styled from 'styled-components'
import zIndex from '../../utils/zIndexScale'
import CancelWhite from '../../static/images/cancelwhite.svg'
import CancelBlack from '../../static/images/cancelblack.svg'

export const Wrapper = styled.div`
  height: 50px;
  line-height: 50px;
  background: ${({ theme, bgColor }) => bgColor || theme.headerBg};
  color: ${({ theme }) => theme.fontColor};
  display: flex;
  flex-direction: row;
  padding: 0 15px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex.header};
  @media (max-width: 768px) {
    height: 44px;
    line-height: 44px;
  }
`

export const StyledSelectLang = styled.div`
  height: 100%;
  .select {
    vertical-align: middle;
    height: 40px;
    line-height: 40px;
    color: inherit;
  }

  @media (max-width: 768px) {
    display: none;
  }
`

export const LeftPane = styled.div`
  display: flex;
`

export const Logo = styled.div`
  color: #f0b90b;
  max-width: 150px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: -15px;
  padding-left: 15px;

  img {
    max-width: 100%;
    height: 25px;
  }
`

export const DateNetWork = styled.div`
  margin-left: 20px;
  padding-top: 10px;
  @media (max-width: 868px) {
    display: none;
  }
`

export const RightPane = styled.div`
  justify-content: flex-end;
  display: flex;
  position: absolute;
  right: 15px;
`

export const Menu = styled.ul`
  display: flex;
  flex-direction: row;
  li {
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    margin-left: 15px;
    cursor: pointer;
    position: relative;

    &:hover {
      background: ${({ theme }) => theme.headerItemHoverBg};
    }

    a {
      height: 100%;
      display: block;
      color: inherit;
      font-size: 14px;
      outline: none;
      &:hover {
        text-decoration: none;
      }
    }
    &:hover ul {
      display: block;
    }
  }
  li.withSubMenus {
    span {
      font-size: 14px;
    }
    ul {
      color: #fff;
    }

    .triangle {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(0, -50%) rotate(0deg);
      transition: transform 0.3s ease-in-out;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid currentColor;
    }
    &:hover .triangle {
      transform: translate(0, -50%) rotate(180deg);
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`

export const MobileMenuIcon = styled.div`
  display: none;
  position: relative;
  cursor: pointer;
  width: 20px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 60px;
    top: 0;
    bottom: 0;
    left: -20px;
  }
  @media (max-width: 768px) {
    display: block;
  }
`

export const ConfirmContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 100px;
    margin-bottom: 20px;
  }
`

export const CancelImg = styled.div`
  width: 100px;
  height: 66px;
  background: ${({ theme }) =>
    theme.mode === 'DARK' ? `url(${CancelBlack})` : `url(${CancelWhite})`};
  background-size: contain;
`

export const SubMenus = styled.ul`
  display: none;
  position: absolute;
  top: 50px;
  right: 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  background: ${({ theme }) => theme.headerDropdownBg};

  li {
    background: ${({ theme }) => theme.headerDropdownBg};
    color: ${({ theme }) => theme.fontColor};
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    text-align: center;
    white-space: nowrap;
    animation: appear 0.3s ease-in-out;
    margin-left: 0;

    &:hover {
      background: ${({ theme }) => theme.headerDropdownItemHoverBg};
      color: ${({ theme }) => theme.highlight};
    }

    @media (max-width: 768px) {
      background: inherit;
    }
  }
`

export const MobileItemTradePair = styled.div`
  font-size: 18px;
  position: relative;
  width: fit-content;
  white-space: nowrap;
  /* width: 115px; */
  /* text-overflow: ellipsis; */
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 40px;
    height: 44px;
    right: -30px;
  }
`

export const MobileItemMoreTradePair = styled.div`
  position: absolute;
  right: -25px;
  top: 0;
`

export const MobileItemBox = styled.div`
  display: none;
  width: 100%;
  margin-left: 20px;
  color: #fff;
  .value {
    margin-left: 8px;
    width: 60px;
    text-align: left;
    white-space: nowrap;
  }
  @media (max-width: 768px) {
    display: block;
  }
  @media (max-width: 319px) {
    display: none;
  }
  @media (max-width: 350px) {
    .trade-pair {
      font-size: 14px;
    }
    .more-trade-pair {
      right: -20px;
    }
  }
`

export const SearchWrap = styled.div`
  position: absolute;
  top: 0;
  right: 50px;
`

export const FavoriteIcon = styled.div`
  display: none;
  cursor: pointer;
  width: 20px;
  top: 0px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 60px;
    top: 0;
    bottom: 0;
    left: -20px;
  }
  @media (max-width: 768px) {
    display: block;
  }
`

const TagWrapper = styled.div`
  display: flex;
  align-items: center;
`

const TagText = styled.div`
  position: relative;
  top: -2px;
  background: rgb(240, 185, 11, 0.1);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  line-height: 14px;
  color: #f0b90b;
  margin-left: 8px;
`

export const MiniTokenTag = () => (
  <TagWrapper>
    <TagText>MiniToken</TagText>
  </TagWrapper>
)
